import { NumberInput, required, TextInput, useTranslate } from 'react-admin';
import { Box, Stack, Typography } from '@mui/material';
import { ThresholdTier, ThresholdTierType } from '../../../services/redpacketService';

interface FormProps {
  isCreate: boolean;
  tierType: ThresholdTierType;
  record?:ThresholdTier;
}

const ThresholdTierForm = (props: FormProps) => {
  const { isCreate, tierType, record } = props;
  const t = useTranslate();

  const numberProps = {
    parse: (v: any) => (v === '' || v == null ? undefined : Number(v)),
    format: (v: any) => (v == null ? '' : v),
    inputProps: {
      inputMode: 'decimal',
      step: 'any',
      onWheel: (e: React.WheelEvent<HTMLInputElement>) => {
        (e.currentTarget as HTMLInputElement).blur();
      },
    } as const,
  } as const;

  return (
    <Stack spacing={3} gap={2}>
      <Stack
        direction={{ xs: 'column', sm: 'row' }}
        alignItems={{ xs: 'stretch', sm: 'center' }}
        spacing={2}
        mb={1}
      >
        <Typography variant="body2" sx={{ flexBasis: '25%', flexShrink: 0 }}>
          {tierType === ThresholdTierType.DEPOSIT ? t('module.redpacket.accumulatedDepositAmount') : t('module.redpacket.cumulativeTradingAmount')}
        </Typography>
        <Box sx={{ flexGrow: 1 }}>
          <NumberInput
            label={false}
            source="thresholdAmount"
            validate={[required()]}
            placeholder={tierType === ThresholdTierType.DEPOSIT ? t('module.redpacket.cumulativeDepositPlaceholder') : t('module.redpacket.cumulativeTradingPlaceholder')}
            fullWidth
            defaultValue={record?.thresholdAmount}
            {...numberProps}
          />
        </Box>
      </Stack>

      <Stack
        direction={{ xs: 'column', sm: 'row' }}
        alignItems={{ xs: 'stretch', sm: 'center' }}
        spacing={2}
        mb={1}
      >
        <Typography variant="body2" sx={{ flexBasis: '25%', flexShrink: 0 }}>
          {t('module.redpacket.packetsEarned')}
        </Typography>
        <Box sx={{ flexGrow: 1 }}>
          <NumberInput
            label={false}
            source="packetsEarned"
            validate={[required()]}
            placeholder={t('module.redpacket.packetsEarnedPlaceholder')}
            fullWidth
            defaultValue={record?.packetsEarned}
            {...numberProps}
          />
        </Box>
      </Stack>


      <Stack
        direction={{ xs: 'column', sm: 'row' }}
        alignItems={{ xs: 'stretch', sm: 'center' }}
        spacing={2}
        mb={1}
      >
        <Typography variant="body2" sx={{ flexBasis: '25%', flexShrink: 0 }}>
          {t('module.redpacket.description')}
        </Typography>
        <Box sx={{ flexGrow: 1 }}>
          <TextInput
            label={false}
            source="description"
            placeholder={t('module.redpacket.descriptionOptional')}
            fullWidth
            multiline
            defaultValue={record?.description}
            rows={3}
          />
        </Box>
      </Stack>
    </Stack>
  );
};

export default ThresholdTierForm;
